export { getEnabledTranslationLangs } from '@paintscout/util/builder/quote/util/translation-langs'

import { SUPPORTED_LANGS } from './supported-langs'
import type { SupportedLang } from './supported-langs'

export function getNormalizedTranslationLang(lang: unknown): SupportedLang {
  if (typeof lang === 'string' && (SUPPORTED_LANGS as readonly string[]).includes(lang)) {
    return lang as SupportedLang
  }

  return 'en'
}
